import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManageProfileComponent } from './manage-profile.component';
import { AddProfileComponent } from './add-profile/add-profile.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { WatchProfileComponent } from './watch-profile/watch-profile.component';

const routes: Routes = [


  {
    path: "",
    component: ManageProfileComponent
  },
  {
    path: "add",
    component: AddProfileComponent
  },
  {
    path: "edit/:id",
    component: EditProfileComponent
  },
  {
    path: "watch",
    component: WatchProfileComponent
  },


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})



export class ManageProfileRoutingModule { }
